import { useRef, useEffect, useState } from "react";

export const useOutsideClick = (props: any) => {
    const [popupView, setPopupView] = useState(props);

    const handlePopupView = () => {
        setPopupView(!popupView);
    };

    const elmRef = useRef<HTMLDivElement>(null);

    const handleClickOutside = (event: any) => {
        if (elmRef.current && !elmRef.current.contains(event.target)) {
            setPopupView(!popupView);
        }
    };

    useEffect(() => {
        window.addEventListener("mousedown", handleClickOutside);

        return () => {
            window.removeEventListener("mousedown", handleClickOutside);
        };
    }, [popupView]);

    return [popupView, elmRef, handlePopupView];
};
